import { useFlag } from '@/features/unleash';
import loadable from '@loadable/component';
import { useSummaryV2 } from '@/hooks/useCompany';
import type { CompanyReportSection } from '@/pages/CompanyReport/useSection';

const PeerCompanies = loadable(() => import('../PeerCompanies'));

interface Props {
  originalElement: JSX.Element;
  section: CompanyReportSection;
}

export const useExperimentPeerCompanies = ({
  originalElement,
  section,
}: Props) => {
  const featureFlag = useFlag({ name: 'mono-experiment-peer-companies' });
  const isExperimentPeerCompanies =
    featureFlag.flagsReady && featureFlag.enabled;
  const { status, name, canonicalUrl } = useSummaryV2();

  if (isExperimentPeerCompanies) {
    if (status !== 'success') {
      return null;
    }
    return (
      <PeerCompanies
        canonicalURL={canonicalUrl}
        name={name}
        section={section}
      />
    );
  }
  return originalElement;
};
